import Card from "../Card";
import PercentChange from "../PercentChange";
import LineChart from "./LineChart";
import VolumeGauge from "./VolumeGauge";

const formatCompactCurrency = (value) => {
  if (!value) return "$0";

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value);
};

const MarketStats = ({ market_summary }) => {

  const marketCap = market_summary?.total_market_cap_usd;
  const volume24h = market_summary?.total_volume_usd;
  const marketCapChange = market_summary?.market_cap_change_percentage_24h ?? 0;
  const btcDominance = market_summary?.btc_dominance_percentage ?? 0;

  const chart = market_summary?.sparklines;

  // Temporary until API returns Fear & Greed
  // const fearGreed = market_summary?.fear_and_greed;

  return (
    <div className="grid gap-2 grid-cols-2 xl:grid-cols-3">
      {/* Market Cap */}
      <Card className="relative h-[159px] overflow-hidden p-4">
        <p className="text-sm sm:text-base font-medium text-text-primary">
          Market Cap
        </p>

        <div className="mt-2 flex items-center gap-2">
          <p className="text-2xl font-semibold text-text-primary">
            {formatCompactCurrency(marketCap)}
          </p>

          <PercentChange
            value={marketCapChange}
            positive={marketCapChange >= 0}
          />
        </div>

        <LineChart data={chart.market_cap} />
      </Card>

      {/* Total Volume */}
      <Card className="relative h-[159px] overflow-visible p-4">
        <div className="flex flex-col gap-2">
          <p className="text-sm sm:text-base font-medium leading-[21px] text-text-primary">
            Total Crypto Volume
            <span className="text-sm font-normal text-text-secondary">
              {" "}
              (24h)
            </span>
          </p>

          <p className="text-2xl font-semibold leading-[19.5px] text-text-primary">
            {formatCompactCurrency(volume24h)}
          </p>
        </div>

        {/* Replace when API exposes historical volume */}
        <VolumeGauge thumbPercent={50} thumbLeft={50} />
      </Card>

      {/* Dominance */}
      <Card className="relative h-[159px] overflow-hidden p-4">
        <div className="flex flex-col gap-2">
          <p className="text-sm sm:text-base font-medium leading-[21px] text-text-primary">
            BTC Dominance
          </p>

          <div className="flex items-center gap-2">
            <p className="text-2xl font-semibold leading-[19.5px] text-text-primary">
              {btcDominance.toFixed(1)}%
            </p>

            <PercentChange
              value={marketCapChange}
              positive={marketCapChange >= 0}
            />
          </div>
        </div>

        <LineChart data={chart.total_volume} />
      </Card>

      {/* Fear & Greed */}
      {/* <Card className="relative h-[159px] overflow-visible p-4">
        <p className="text-sm sm:text-base font-medium leading-[21px] text-text-primary">
          Fear &amp; Greed
        </p>

        <FearGreedGauge value={fearGreed?.value} label={fearGreed?.classification} />
      </Card> */}
    </div>
  );
};

export default MarketStats;
